define('modules/stats/views/listing',['require','exports','module','base/collectionview','./listing_item','services/auth/info','ldsh!../templates/listing'],function (require, exports, module) {
  'use strict';

  var CollectionView = require('base/collectionview'),
    ListingItemView = require('./listing_item'),
    AuthInfo = require('services/auth/info'),
    authInfo = new AuthInfo();

  var ListingView = CollectionView.extend({
    initialize: function (options) {},
    template: require('ldsh!../templates/listing'),
    tagName: 'table',
    className: 'ed-table ed-table-striped',
    itemContainer: '.js-item-container',
    itemView: ListingItemView,
    defaultFormFields: [],
    integrationFormFields: [],

    onRender: function () {
      this.$el.i18n();
    },
    helpers: function () {
      var self = this;
      var fields = { sumVisitors: 0, sumVisits: 0, sumConvert: 0, sumPages: 0 };
      this.collection.reduce(function (columnNames, model) {
        if (self.showItem(model.get('company_id'))) {
          columnNames.sumVisitors += parseInt(model.get('visits'));
          columnNames.sumVisits += parseInt(model.get('impressions'));
          columnNames.sumConvert += parseInt(model.get('conversion'));
          columnNames.sumPages += parseInt(model.get('num_pages'));
        }
        return columnNames;
      }, fields);

      return fields;
    },
    showItem: function (company_id) {
      return (
        authInfo.getCompanies() &&
        _.filter(authInfo.getCompanies(), function (company) {
          return company_id == company.id;
        }).length
      );
    },
  });

  module.exports = ListingView;
});

